import BoardTextBody from '../board-text-body/BoardTextBody';
import { ARTICLE_BODY_COMPOSITION } from '../board-text-body/composition';

export default function ArticleBodyEditor(props) {
  return <BoardTextBody {...props} composition={ARTICLE_BODY_COMPOSITION} />;
}
